// extracted by mini-css-extract-plugin
export default {"wrapper":"photo_wrapper__obQcr","viewer":"photo_viewer__u-mDv"};